import Model, { attr } from '@ember-data/model';

export default class BookingRentalAgreementSettingModel extends Model {
  @attr('string', { defaultValue: '' }) content!: string;
  @attr('boolean') enabledForUplisting!: boolean;
  @attr('boolean') enabledForBookingDotCom!: boolean;
  @attr('boolean') enabledForAirbnb!: boolean;
  @attr('boolean') enabledForHomeAway!: boolean;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'booking-rental-agreement-setting': BookingRentalAgreementSettingModel;
  }
}
